import Cookies from "js-cookie";
import { BannersBlock, ExperienceHighlightsBlock, HeroBlock, HighlightedPrograms, HighlightsBlock, PopularProgramsBlock, TicketsBlock, TopPicksBlock, prepHomeRoute, prepHomeView, } from "pages/home";
export var prePrepHomeRoute = function () {
    var hidePlusBanner = Cookies.get("isPlusUser") === "true" || Cookies.get("plusBannerIsSeen");
    var firstBanner = hidePlusBanner
        ? BannersBlock.block("banner1")
        : BannersBlock.block("plusBanner");
    var secondBanner = hidePlusBanner
        ? BannersBlock.block("banner2")
        : BannersBlock.block("banner1");
    var thirdBanner = hidePlusBanner
        ? BannersBlock.block("banner3")
        : BannersBlock.block("banner2");
    var highlightedPrograms1 = HighlightedPrograms.block(1);
    var highlightedPrograms2 = HighlightedPrograms.block(2);
    var highlightedPrograms3 = HighlightedPrograms.block(3);
    return prepHomeRoute(prepHomeView([
        HeroBlock.block,
        TopPicksBlock.block,
        HighlightsBlock.block,
        PopularProgramsBlock.block,
        firstBanner,
        highlightedPrograms1,
        secondBanner,
        highlightedPrograms2,
        ExperienceHighlightsBlock.block,
        TicketsBlock.block,
        thirdBanner,
        highlightedPrograms3,
    ]));
};
